import SimpleFillSymbol from "@arcgis/core/symbols/SimpleFillSymbol";
import Graphic from "@arcgis/core/Graphic";

export function ZoomIn(geometry, geometryType, mapView) {

    let type = geometryType

    const symbol = new SimpleFillSymbol({
        color: [51, 255, 233, 0.8],
        outline: {
            color: [255, 255, 255],
            width: 1,
        },
    });

    if (type == "point") {
        mapView.scale = 15000
        mapView.goTo({
            target: geometry,
            zoom: 15
        })
    } else if (type == "polygon") {
        const graphic = new Graphic({
            geometry: geometry,
            symbol: symbol,
        });
        mapView.graphics.add(graphic);
        mapView.goTo(geometry.extent.expand(1.5));
        setTimeout(() => {
            mapView.graphics.remove(graphic);
        }, 3000);
    } else if (type == "polyline") {
        mapView.goTo(geometry.extent)
    }
}